import { MatDialog } from '@angular/material/dialog';
import { LogService } from '@pershing/pershing-core';
import { CancelOrderComponent } from './cancel-order.component';
import { OrderActionParams } from './../../../models/common/order-status.model';
import { Account } from './../../../models/common/trading-common.model';
import { TradingEntitlements } from './../../../models/common/trading-entitlements';
import { getDialogWidth } from '../../../utils/trading-common';

export function openCancelOrderDialog(_dialog: MatDialog, _logService: LogService, params: OrderActionParams, account: Account,
                                      tradingEntitlements: TradingEntitlements, ordQty?: any) {
    const cancelOrderDialogRef = _dialog.open(CancelOrderComponent, {
        panelClass: 'modal',
        disableClose: true,
        width: getDialogWidth(window.innerWidth),
        maxWidth: '70vw',
        autoFocus: false,
        data: {
            params: params,
            account: account,
            tradingEntitlements: tradingEntitlements,
            ordQty: ordQty
        }
    });

    cancelOrderDialogRef.afterClosed().subscribe((data) => {
        _logService.log('The cancelOrderDialogRef was closed', data);
    });
}
